import {createApp} from 'vue'
import '@/assets/vue-multiselect.css'
import App from "@/App.vue";
import router from './router/app'
import store from './store/app'
import i18n from '@/boot/i18n'

import registerCommon from './boot/common';
import registerFontAwesome from './boot/fontawesome';
import registerVuelidate from './boot/vuelidate';
import registerNotifications from './boot/notifications';
import registerMetaInfo from './boot/metaInfo';
import registerHasAccessRights from './boot/hasAccessRights';
import registerHasProviderAccessRights from './boot/hasProviderAccessRights';
import registerSwitchTheme from './boot/switchTheme';
import registerFilters from '@/boot/filters';

const app = createApp(App)

registerCommon(app);
registerFontAwesome(app);
registerFilters(app);
registerVuelidate(app);
registerNotifications(app);
registerMetaInfo(app);
registerHasAccessRights(app);
registerHasProviderAccessRights(app);
registerSwitchTheme(app);

app.use(router)
app.use(store)

app.config.globalProperties.$hasListener = function (listenerName) {
  return !!(this.$.vnode.props?.[listenerName] ?? this.$attrs?.[listenerName]);
};


app.use(i18n)

app.mount('#app')
